export default {
	title: "Persönliches Zentrum",
	subTitle: ["Profil", "Sicherheit", "System"],
	menu: [
		"Persönliche Informationen ändern",
		"Benutzername",
		"Passwort aktualisieren",
		"Transaktionspasswort aktualisieren"
	],
	updatePassword: {
		form: {
			label: ["Altes Passwort", "Neues Passwort", "Neues Passwort bestätigen"]
		}
	},
	updateTransactionPassword: {
		form: {
			label: ["Altes Passwort", "Neues Passwort", "Neues Passwort bestätigen"]
		}
	}
};
